<template>
    <div class="line" :class="'property_' + property.propertyId">
        <span class="label">
            {{ property.property.names.name }} 
        </span>
        <span class="text">
             <template v-if="surcharge > 0">
                <template v-if="isAdditionalCost || isTaxless">
                    {{ $translate("Ceres::Template.basketPlusAbbr") }} {{ surcharge | currency }}
                </template>
                <template v-else>
                    {{ $translate("Ceres::Template.basketIncludeAbbr") }} {{ surcharge | currency }}
                </template>
            </template>
        </span>
    </div>
</template>

<script>
import { hasVat, isAdditionalCosts } from "../../helper/OrderPropertyHelper";
export default {
    name: "order-property-value-list-item",

    props:
    {
        property:
        {
            required: true,
            type: Object
        }
    },

    computed:
    {
        surcharge()
        {
            return this.$options.filters.propertySurcharge([this.property], this.property.propertyId);
        },

        isAdditionalCost()
        {
            return isAdditionalCosts(this.property);
        },

        isTaxless()
        {
            return !hasVat(this.property) && App.useVariationOrderProperties;
        },

        showColon()
        {
            return this.property && this.property.property.value && this.property.property.valueType !== "empty";
        }
    }
}
</script>
